import algoliasearch from 'algoliasearch/lite';
import { ALGOLIA_API_KEY, ALGOLIA_APP_ID } from '../constants/algolia_constants';
import { canOpenSpeakerProfile } from '../components/speakerHelper';

let speakersIndex;

export const speakersFromSearchHits = (hits) => {
    const seen = new Set();
    return hits.map((hit) => hit?.speaker).filter((speaker) => {
        if (typeof speaker?.id !== 'string' || !speaker.id.trim() ||
            typeof speaker.name !== 'string' || !canOpenSpeakerProfile(speaker) ||
            seen.has(speaker.id)) return false;
        seen.add(speaker.id);
        return true;
    });
};

export const searchSpeakers = async (query) => {
    const trimmedQuery = query.trim();
    if (!trimmedQuery) return [];

    if (!speakersIndex) {
        speakersIndex = algoliasearch(ALGOLIA_APP_ID, ALGOLIA_API_KEY).initIndex('speakers');
    }
    const { hits } = await speakersIndex.search(trimmedQuery, { hitsPerPage: 20 });
    if (!Array.isArray(hits)) throw new Error('Unable to load speakers.');

    return speakersFromSearchHits(hits);
};
